/*
  Kalessie - cart page enhancements: re-renders the cross-sell row after a
  quantity change / remove, so it stops offering what is already in the cart.
  The order summary re-renders itself, live, inside #main-cart-footer
  .js-contents.

  The checkout button carries no total: it sits outside that live region, so a
  figure printed on it would go stale, and the summary directly above it
  already shows the amount. Payment method is chosen on Shopify's checkout.
*/
(function () {
  function refreshCrossSell() {
    var el = document.getElementById('shopify-section-cart_cross_sell');
    if (!el) return;
    fetch(window.location.pathname + '?sections=cart_cross_sell', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.cart_cross_sell) el.innerHTML = data.cart_cross_sell;
      })
      .catch(function () {});
  }

  function onUpdate() {
    refreshCrossSell();
  }

  function initClearAll() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-kal-clear]') : null;
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    });
  }

  function init() {
    initClearAll();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onUpdate);
    }
    document.addEventListener('cart:updated', onUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
